import NavBar from '../components/layout/NavBar';
import HeroSection from '../components/marketing/HeroSection';
import BrandStatement from '../components/marketing/BrandStatement';
import ProductShowcase from '../components/marketing/ProductShowcase';
import CraftSection from '../components/marketing/CraftSection';
import CTASection from '../components/marketing/CTASection';
import Footer from '../components/layout/Footer';

export const Home = () => {
  return (
    <div data-testid="home-page" className="min-h-screen bg-tex-bg">
      {/* TECHNIQUE 5: Grain Texture Overlay */}
      <div className="grain-overlay" />
      
      <NavBar />
      <main>
        <HeroSection />
        <BrandStatement />
        <ProductShowcase />
        <CraftSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
